import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClipboardCheck, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";

// Compact dashboard card — only renders when there are pending approvals.
export function ApprovalsSummaryCard() {
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    const load = () => api.get("/approvals/summary").then((r) => setCount(r.data?.count || 0)).catch(() => {});
    load();
    const iv = setInterval(load, 20000);
    return () => clearInterval(iv);
  }, []);
  if (!count) return null;
  return (
    <button
      data-testid="dashboard-approvals-card"
      onClick={() => navigate("/approvals")}
      className="liquid-glass-card flex w-full items-center justify-between gap-3 border border-[#F5D9A8]/70 p-4 text-left transition-all hover:scale-[1.005] active:scale-[0.99]"
    >
      <div className="flex items-center gap-3">
        <span className="grid h-10 w-10 place-items-center rounded-full bg-[#FFF1E6] text-[#B5590F]">
          <ClipboardCheck className="h-5 w-5" />
        </span>
        <div>
          <p className="text-[14px] font-semibold text-[#1D1D1F]">Approvals</p>
          <p className="text-[12.5px] text-[#8E8E93]" data-testid="dashboard-approvals-count">{count} Pending</p>
        </div>
      </div>
      <ChevronRight className="h-5 w-5 text-[#B5590F]" />
    </button>
  );
}

export default ApprovalsSummaryCard;
